'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import AppLink from '@/components/elementary/AppLink';
import { NavbarMenuLink } from '@/components/elementary/navbar/NavbarMenuLink';
import { Paragraph } from '@/components/typography/Paragraph';
import { Button } from '@/components/ui/button';
import { NavigationMenuContent, NavigationMenuItem, NavigationMenuTrigger } from '@/components/ui/navigation-menu';
import { cn } from '@/lib/styles';
import { NAVBAR_TEST_IDS } from '@/lib/test-ids';
interface CTAButtonsProps {
  login?: Data.Component<'utilities.link'> | null;
  buttons?: Data.Component<'utilities.link'>[] | null;
  dropdown?: Data.Component<'layout-utilities.dropdown-item'> | null;
  minimal?: boolean;
}
export function CTAButtons(t0) {
  const $ = _c(13);
  const {
    login,
    buttons,
    dropdown,
    minimal
  } = t0;
  let t1;
  if ($[0] !== login || $[1] !== minimal) {
    t1 = login?.href && login?.label ? <div className={cn("flex items-center xl:w-fit w-full min-h-8", minimal && "mr-2")}><AppLink link={login} size={minimal ? "small" : null} variant={minimal ? "secondary" : "primaryLink"} data-test-id={NAVBAR_TEST_IDS.LOGIN_BUTTON}>{minimal ? login.label : <Paragraph fontSize="bodyRegularMedium" className="text-inherit">{login.label}</Paragraph>}</AppLink>{!minimal && <div className="mx-4 w-px bg-neutral-light-500 h-6" />}</div> : null;
    $[0] = login;
    $[1] = minimal;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== buttons) {
    t2 = buttons && buttons.length > 0 ? buttons.map(_temp) : null;
    $[3] = buttons;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== dropdown) {
    t3 = dropdown?.label && dropdown.links && dropdown.links?.length > 0 ? <NavigationMenuItem><Button variant="secondary" size="small" asChild={true}><NavigationMenuTrigger className="[&>svg]:hidden">{dropdown.label}</NavigationMenuTrigger></Button><NavigationMenuContent className="min-w-61.5 p-4 border-none shadow-box divide-y divide-neutral-light-500 left-[unset] right-0" asChild={true}><ul>{dropdown?.links?.map(_temp2)}</ul></NavigationMenuContent></NavigationMenuItem> : null;
    $[5] = dropdown;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t2 || $[8] !== t3) {
    t4 = <div className="flex xl:flex-row flex-col items-center gap-2 xl:w-fit w-full">{t2}{t3}</div>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t4) {
    t5 = <div className="flex items-center justify-end w-full">{t1}{t4}</div>;
    $[10] = t1;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function _temp2(link) {
  return <li key={link.id} className="block py-2"><NavbarMenuLink link={link} data-test-id={NAVBAR_TEST_IDS.DROPDOWN_ITEM} isDropDownItem={true} /></li>;
}
function _temp(primaryButton) {
  return primaryButton.href ? <AppLink key={primaryButton.id} size="small" variant="primary" link={primaryButton} data-test-id={NAVBAR_TEST_IDS.PRIMARY_BUTTON}>{primaryButton.label}</AppLink> : null;
}